  <!-- ------------------Page Heading Start------------- -->

  <div class="page_heading">
    <div class="container">
        <h2>E - Commerce Solution</h2>
    </div>
</div>

<!-- ------------------Page Heading End------------- -->

<!-- ------------------Services web development Start-------------->
<section class="why-choos-lg pad-tb deep-dark">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="common-heading text-l">
            <h2 class="mb20">BEST <span class="text-second text-bold">E - Commerce Solution Agency</span> Among The Leading Companies in India</h2>
            <p>Any business that wants to sell their products and services across the internet have to opt for ecommerce solutions to support their business at different stages. With the availability of resources and an increase in the competition, there are several ecommerce solutions in the market. Being a merchant, it’s your responsibility to research, analyze, and compare the ecommerce solutions and opt for the one that’s of greater utility.</p>
            <!-- <div class="itm-media-object mt40 tilt-3d">
              <div class="media">
                <div class="img-ab- base" data-tilt="" data-tilt-max="20" data-tilt-speed="1000"><img loading="lazy" src="assets/images/computers.png" alt="icon" class="layer"></div>
                <div class="media-body">
                  <h4>Quality Web Content</h4>
                  <p>Content should include important information and come in the forms that are pertinent to the website.</p>
                </div>
              </div>
              <div class="media mt40">
                <div class="img-ab- base" data-tilt="" data-tilt-max="20" data-tilt-speed="1000"><img loading="lazy" src="assets/images/worker.png" alt="icon" class="layer"></div>
                <div class="media-body">
                  <h4>Sensible Web design</h4>
                  <p>Balanced distribution of content and graphics is required and the use of slightly contrasting colours and clear fonts is key.</p>
                </div>
              </div>
              <div class="media mt40">
                <div class="img-ab- base" data-tilt="" data-tilt-max="20" data-tilt-speed="1000"> <img loading="lazy" src="assets/images/deal.png" alt="icon" class="layer"></div>
                <div class="media-body">
                  <h4>CMS Websites</h4>
                  <p>Content management system complements a website by providing website owners with the tools to manage their website’s content themselves.</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="col-lg-6">
          <div data-tilt="" data-tilt-max="5" data-tilt-speed="1000" class="single-image bg-shape-dez wow fadeIn" data-wow-duration="2s" style="visibility: visible; animation-duration: 2s; animation-name: fadeIn; will-change: transform; transform: perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1);"><img loading="lazy" src="assets/images/web-application_new.png" alt="image" class="img-fluid"></div>

         
        </div>
      </div>
    </div>
  </section>
  
  <!-- ------------------Services web development End---------------->

<!-- shared closing CTA -->
<app-service-cta></app-service-cta>
